<script setup>
import TheAccountPlaceholder from '@/components/account/atoms/TheAccountPlaceholder.vue'
import TheAccountNavigation from '@/components/account/molecules/TheAccountNavigation.vue'
import {
  ACCOUNT_ACTIONS,
  ACCOUNT_ACTION_COMPONENT_KEYS,
  ACCOUNT_NAV_ITEMS
} from '@/constants/AccountConstants.js'
import { translate } from '@/plugins/i18n.js'
import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const ACCOUNT_ACTION_COMPONENTS = {
  placeholder: TheAccountPlaceholder
  // Add further components here, then set their key in ACCOUNT_ACTION_COMPONENT_KEYS
}

const props = defineProps({
  action: {
    type: String,
    default: ''
  }
})

const currentAction = computed(() => props.action || route.params.action)

const currentComponent = computed(() => {
  const key = ACCOUNT_ACTION_COMPONENT_KEYS[currentAction.value]
  return ACCOUNT_ACTION_COMPONENTS[key] || TheAccountPlaceholder
})

const currentItem = computed(() =>
  ACCOUNT_NAV_ITEMS.find((item) => item.action === currentAction.value)
)

const breadcrumbs = computed(() => [
  {
    title: translate('account_nav_my_account'),
    to: { name: 'account_default' }
  },
  {
    title: currentItem.value ? translate(currentItem.value.labelKey) : '',
    disabled: true
  }
])

// Redirect to profile if no action or invalid action
watch(
  () => route.params.action,
  (action) => {
    if (route.name === 'account_default' || !action) {
      router.replace({
        name: 'account_action',
        params: { action: ACCOUNT_ACTIONS.PROFILE }
      })
    }
  },
  { immediate: true }
)
</script>

<template>
  <VContainer>
    <VBreadcrumbs :items="breadcrumbs" class="account-breadcrumbs px-0 mb-2" />
    <VRow>
      <VCol cols="12" md="4">
        <TheAccountNavigation />
      </VCol>
      <VCol cols="12" md="8" class="pl-md-3 pt-3 pt-md-0">
        <component :is="currentComponent" :action="currentAction" />
      </VCol>
    </VRow>
  </VContainer>
</template>

<style scoped>
.account-breadcrumbs :deep(.v-breadcrumbs-item--disabled) {
  opacity: 1;
  color: rgb(var(--v-theme-on-surface));
}
</style>
